import React from 'react'

import { useDecision } from '@optimizely/react-sdk'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { useDoubleDeckerNav } from 'hooks/useDoubleDeckerNav'
import { useMenu } from 'routes/Menu/domains/menu'

import css from './CollectionItem.css'

const CollectionItem = ({
  collectionId,
  className,
  dataId,
  onClick,
  identifier,
  element,
  children,
  slug,
  shortTitle,
}) => {
  const { getRecipesForCollectionId } = useMenu()
  const count = getRecipesForCollectionId(collectionId).recipes.size
  const doubleDeckerExperimentEnabled = useDoubleDeckerNav()

  const [curatedBoxesOFXDecision] = useDecision('beetroots_ofx_curated_boxes_v2_test')
  const isCuratedBoxesV2Enabled = curatedBoxesOFXDecision.variationKey === 't1'

  return (
    <div
      data-id={dataId}
      className={className}
      onClick={onClick}
      key={identifier}
      ref={element}
      data-slug={slug}
      shortTitle={shortTitle}
    >
      {children}
      <span
        className={classnames({
          [css.count]: !doubleDeckerExperimentEnabled,
          [css.doubleDeckerCount]: doubleDeckerExperimentEnabled,
        })}
      >
        {isCuratedBoxesV2Enabled && shortTitle === 'Pre-selected boxes' ? null : `(${count})`}
      </span>
    </div>
  )
}

CollectionItem.propTypes = {
  collectionId: PropTypes.string.isRequired,
  dataId: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  identifier: PropTypes.string.isRequired,
  element: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  slug: PropTypes.string.isRequired,
  shortTitle: PropTypes.string.isRequired,
}

export { CollectionItem }
